module.exports = __webpack_public_path__ + "static/media/Skull.2be5b7c1.ogg";